// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/production/${file}.vue`);

export default [
  {
    path: "/work-order",
    name: "ork-order",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "WorkOrder",
    },
    components: {
      content: lazyLoad("work-order"),
    },
  },
  {
    path: "/production-schedule",
    name: "production-schedule",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSchedule",
    },
    components: {
      content: lazyLoad("production-schedule"),
    },
  },
  {
    path: "/work-order-material-availability-status",
    name: "work-order-material-availability-status",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "WorkOrderMaterialAvailabilityStatus",
    },
    components: {
      content: lazyLoad("work-order-material-availability-status"),
    },
  },
  {
    path: "/work-order-material-availability-status/review/:id",
    name: "work-order-material-availability-status-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "WorkOrderMaterialAvailabilityStatus",
    },
    components: {
      content: lazyLoad("work-order-material-availability-status"),
    },
  },
  {
    path: "/work-order-material-availability-status/edit/:id",
    name: "work-order-material-availability-status-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "WorkOrderMaterialAvailabilityStatus",
    },
    components: {
      content: lazyLoad("work-order-material-availability-status"),
    },
  },
  {
    path: "/production-calendar/:tab*",
    name: "production-calendar",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSchedule",
    },
    components: {
      content: lazyLoad("production-calendar"),
    },
  },
];
